<script>
    import Centering from '../layouts/Centering.svelte'
    export let title,date,content
</script>

<Centering>
    <article>
        <div class="article-header">
            <span class="article-header-date">{date}</span>
            <h3>{title}</h3>
        </div>
        <main class="html-content">
            {@html content}
        </main>
    </article>
</Centering>

<style>
    article{
        width: 100%;
        margin-top: 75px;
    }
    .title{
        display: flex;
        align-items: center;
    }
    .title h2{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 60px;
        line-height: 36px;
        text-align: left;
        color: #000;
    }
    .page-sub{
        font-size: 16px;;
        font-family: "Noto Sans JP",sans-serif;
        line-height: 36px;
        margin-left: 22px;
    }
    .article-header{
        margin-top: 50px;
        width: 100%;
        height: 66px;
        border-bottom: 1px solid #000;
        display: flex;
        align-items: baseline;
        margin-bottom: 30px;
    }
    .article-header-date{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 16px;
        line-height: 0px;
        color: #000;
    }
    .article-header h3{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 24px;
        line-height: 0px;
        color: #000;
        margin-left: 100px;
    }
    @media screen and (max-width:640px){
        article{
            margin-top: 60px;
        }
        .title{
            flex-direction: column;
            align-items: start;
        }
        .title h2{
            line-height: 87px;
            margin: 0;
        }
        .page-sub{
            margin-left: 0;
        }
        .article-header{
            flex-direction: column-reverse;
            height: 95px;
            margin-top: 55px;
        }
        .article-header h3{
            font-size: 20px;
            line-height: 41px;
            margin-left: 0px;
        }
        .article-header-date{
            line-height: 20px;
            margin-bottom: 30px;
        }
    }
</style>